import { FormHookInput, FormHookTextArea, Input, Loader, Button, convertDollarToCents, avoidEmptyStringValidator, only2DecimalNumber, generateOnlyNumberRegex, onlyPercentageValidation, formatNumber} from "@thdinc/hpf-shared";
import SelectInput from "@/components/selectInput/SelectInput";
import SelectSearchInput from "@/components/selectInput/SelectSearchInput";
import { FaCirclePlus } from "react-icons/fa6";
import {
  addOnsTypes,
  guestsPerBartender,
  hoursToRegister,
  PACKAGES_TYPES,
  SUPPLIES,
  TIPS_OPTIONS,
} from "@/constants/CompanyData";
import { AddIcon, DeleteIcon, EditIcon } from "@/constants/utils/svgs";
import DashboardLayout from "@/layouts/DashboardLayout";
import React, { useEffect, useRef, useState } from "react";
import { SubmitHandler, useForm, useWatch } from "react-hook-form";
import useError from "@/hooks/useError ";
import useLoading from "@/hooks/useLoading";
//import ImageUploadFunDropZone from "@/constants/utils/ImageUploadDropZoneFun";
import { useAppSelector } from "@/hooks/hook";
import { API_ROUTES } from "@/services/environment";
import { GET, PATCH, POST_MULTIPART } from "@/services/api";
import ChangesAlert from "@/components/alert/ChangesAlert";
import Alert from "@/components/alert/Alert";

import { useNavigate, useParams } from "react-router";
import Dropzone from "@/components/dropzone/DropZone";
import ImageUploadFunDropZone from "@/constants/utils/ImageUploadDropZoneFun";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import { AddOnsInterface } from "@/pages/company/interface";
import { SlKey } from "react-icons/sl";
import FormModal from "@/components/modals/FormModal";
import { FiEdit2 } from "react-icons/fi";
import DashboardHeader from "@/components/DashboardHeader";
import deleteIcon from "../../../assets/icons/deleteIcon.svg";

interface addOnInterFace {
  id?: string;
  img: string;
  name: string;
  price: string;
  description: string;
  type: string;
  auto_include: boolean;
}
type PackageForm = {
  packageName: string;
  prepTime: number;
  tipFee: number;

  bartenderCosts: number;
  deliveryFee: number;

  description: string;
  suppliesPrice: number;
  suppliesCosts: number;
  bartenderProfit: number;
  minPrice: number;
};

const NewPackageBTC = () => {
  const dispatch = useDispatch();
  const { business_id } = useAppSelector((store) => store.user);
  const { addPackageApi, packageGarnishes,packages,singlePackageApi } = API_ROUTES;

  const { refreshToken } = useAppSelector((store) => store.user);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
    trigger,
    control,
  } = useForm<PackageForm>({ defaultValues: { prepTime: 60 } });
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [error, setCustomError] = useError();
  const [suppliesError, setSuppliesError] = useState<string>("");
  const [hrToRegister, setHrToRegister] = useState("3");
  // const [isModalOpen, setIsModalOpen] = useState(false);

  //const [packageImg, setPackageImg] = useState<File | null>(null);
  const [suppliesList, setSuppliesList] = useState(SUPPLIES); // all supplies list
  const [selectedSupplies, setSelectedSupplies] = useState<string[]>([]); // selected list
  const [addOns, setAddOns] = useState<any>([]); // selected list
  // const [notIncludedSupplies, setNotIncludedSupplies] = useState<string[]>([]); // selected list
  const [addSupplyForm, setAddSupplyForm] = useState<boolean>(false); // open or close add supply form
  const [addAddOnForm, setAddOnForm] = useState<boolean>(false);
  const [addOnIsEdit, setAddOnIsEdit] = useState<boolean>(false);
  const [addOnImage, setAddOnImage] = useState<{ file?: File; img: string }>();
  const [addOnId, setAddOnId] = useState<string>();
  const [includeInPackage, setIncludeInPackage] = useState<boolean>(false);
  const [addOnName, setAddOnName] = useState<string>("");
  const [addOnType, setAddOnType] = useState<string>("bartender");
  const [addOnPrice, setAddOnPrice] = useState<string>("");
  const [addOnDesc, setAddOnDesc] = useState<string>("");
  const [supplyInput, setSupplyInput] = useState<string>("");
  const [selectedType, setSelectedType] = useState<string>("standard");
  const [selectedGuests, setSelectedGuests] = useState<string>("25");
  const [tipSelect, setTipSelect] = useState<string>("false");
  const [startTimeState, setStartTimeState] = useState("00:00");
  const [endTimeState, setEndTimeState] = useState("23:30");
  const [payloadState, setPayloadState] = useState<any | null>(null);
  const [modal, setModal] = useState<boolean>(false);
  const [addError, setAddError] = useState<string>("");
  const [addOnError, setAddOnError] = useState<string>("");
  const openModal = () => setAddSupplyForm(true);
  const closeModal = () => {
    setAddSupplyForm(false);
  };
  const openAddOnModal = () => setAddOnForm(true);
  const closeAddOnModal = () => setAddOnForm(false);
  // unsaved changes
  // Get the initial values when the component mounts
  const initialValues: PackageForm = getValues();

  // State to track the previous values
  const [previousValues, setPreviousValues] =
    useState<PackageForm>(initialValues);

  // Ref to track if it's the first render
  const isInitialRender = useRef(true);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      // Skip the effect on the first render
      if (isInitialRender.current) {
        isInitialRender.current = false;
        return;
      }

      dispatch(formStateChange(false));

      // Compare new values with the previous values
      const hasChanged = (Object.keys(value) as Array<keyof PackageForm>).some(
        (key) => value[key] !== previousValues[key]
      );

      if (hasChanged) {
        // dispatch(formStateChange(true));

        // Set previous values to the current values
        setPreviousValues(value as PackageForm);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, previousValues, dispatch]);

  

  // add new supply to list
  const addNewSupply = () => {
    dispatch(formStateChange(true));

    if (
      suppliesList.findIndex(
        (item) => item.toLowerCase() === supplyInput.toLowerCase()
      ) > -1
    ) {
      setAddError("Supply already exists");
      return;
    }

    if (supplyInput.length > 0) {
      setSuppliesList([...suppliesList, supplyInput]);
      setSelectedSupplies([...selectedSupplies, supplyInput]);
      setValue(
        "description",
        generateDescription([...selectedSupplies, supplyInput])
      );
      setSupplyInput("");
      setAddError("");
      setAddSupplyForm(false);
    }
  };

  const addAddOn = () => {
    dispatch(formStateChange(true));

    if (addOnName == "") {
      setAddOnError("Name is required");
      return;
    }
    if (
      addOnPrice == "" ||
      parseInt(addOnPrice) < 0 ||
      parseInt(addOnPrice) > 999
    ) {
      setAddOnError("Enter valid price (0-999)");
      return;
    }
    setAddOnError("");
    const obj = {
      name: addOnName,
      type: addOnType,
      price: parseFloat(addOnPrice),
      description: addOnDesc,
      addonImage: addOnImage,
      auto_include: includeInPackage,
    };
    setAddOns([...addOns, obj]);
    setValue(
      "description",
      generateDescription(selectedSupplies) +
        "\n" +
        generateAddsOnDescription([...addOns, obj])
    );
    setAddOnForm(false);
    setAddOnName("");
    setAddOnType("bartender");
    setAddOnPrice("");
    setAddOnDesc("");
    setAddOnImage({ img: "" });
    setIncludeInPackage(false);
  };
  const updateAddon = (name: string, auto_include: boolean) => {
    dispatch(formStateChange(true));

    const updated = addOns.map((item: any) => {
      if (item.name === name) {
        return { ...item, auto_include: auto_include };
      }
      return item;
    });
    setValue(
      "description",
      generateDescription(selectedSupplies) +
        "\n" +
        generateAddsOnDescription(updated)
    );
    setAddOns(updated);
  };
  const deleteAddOn = (myindex: number) => {
    const updated = addOns.filter(
      (item: any, index: number) => index !== myindex
    );
    setAddOns(updated);
    setValue(
      "description",
      generateDescription(selectedSupplies) +
        "\n" +
        generateAddsOnDescription(updated)
    );
  };
  // select supplies and update the state
  const selectSupply = (checked: boolean, name: string) => {
    dispatch(formStateChange(true));

    if (checked) {
      setSelectedSupplies(selectedSupplies.filter((s) => s !== name));
      setValue(
        "description",
        generateDescription(selectedSupplies.filter((s) => s !== name)) +
          "\n" +
          generateAddsOnDescription(addOns)
      );
    } else {
      setValue(
        "description",
        generateDescription([...selectedSupplies, name]) +
          "\n" +
          generateAddsOnDescription(addOns)
      );
      setSelectedSupplies((prev) => [...prev, name]);
    }
    // if (notIncludedSupplies.includes(name)) {
    //   const data = notIncludedSupplies.filter((item) => item !== name);
    //   setNotIncludedSupplies(data);
    // }
  };
  const generateDescription = (supplies: string[]) => {
    // generates a description from selected supplies
    if (supplies.length == 0) {
      return "";
    }

    return `Includes:
${supplies.length > 0 ? `→ ${supplies.join("\n→ ")}` : ""}`;
  };

  const generateAddsOnDescription = (array: AddOnsInterface[]) => {
    //generates a description from the array of add ons
    if (array.length == 0) {
      return "";
    }
    const included = array
      .filter((item: any) => {
        if (item.auto_include) {
          return item.name;
        }
      })
      .map((item) => item.name);

    const exclded = array
      .filter((item: any) => {
        if (!item.auto_include) {
          return item.name;
        }
      })
      .map((item) => item.name);

    return `${
      exclded.length > 0
        ? `Add-ons (for an additional charge):
→ ${exclded.join("\n→ ")}`
        : ""
    }
${
  included.length > 0
    ? `Add-ons (Included):
→ ${included.join("\n→ ")}`
    : ""
}
`;
  };

  const onSubmit: SubmitHandler<PackageForm> = async (data) => {
    if (selectedSupplies.length == 0) {
      setSuppliesError("Supplies not selected");
      return;
    }
    setSuppliesError("");
    if (selectedType.length > 0) {
      const formData = new FormData();
      formData.append("name", data.packageName);
      formData.append("hourToRegister", hrToRegister);
      formData.append("startTime", startTimeState);
      formData.append("endTime", endTimeState);
      formData.append("bartenderPrepTime", data?.prepTime.toString());
      formData.append("guestPerBartender", selectedGuests);
      formData.append("type", selectedType);
      (data.minPrice && formData.append(
        "minPrice",
        convertDollarToCents(data.minPrice.toString())
      ));

      // tips optional for client side
      formData.append("tips", tipSelect == "true" ? "false" : "true");
      if (tipSelect != "true") {
        formData.append(
          "tipsFee",
          convertDollarToCents(data?.tipFee.toString())
        );
      }
      formData.append(
        "bartenderPrice",
        convertDollarToCents(
          (
            Number(data.bartenderCosts ? data.bartenderCosts : 0) +
            Number(data.bartenderProfit ? data.bartenderProfit : 0)
          ).toString()
        )
      );
      formData.append(
        "bartenderCost",
        convertDollarToCents(Number(data.bartenderCosts).toString())
      );
      formData.append(
        "deliveryFee",
        convertDollarToCents(data?.deliveryFee.toString())
      );
      formData.append("description", data?.description);
      //formData.append("packageImg", packageImg);
      formData.append(
        "suppliesFee",
        convertDollarToCents(
          (Number(data.suppliesPrice / 100) * data.suppliesCosts)
            .toFixed(2)
            .toString()
        )
      ); // for profit calculation
      formData.append(
        "suppliesCost",
        convertDollarToCents(Number(data.suppliesCosts).toFixed(2).toString())
      );
      formData.append("business_id", business_id as string);
      // for add ons list items
      addOns.map((item: any, index: number) => {
        formData.append(`packageAddons[${index}][name]`, item?.name);
        formData.append(
          `packageAddons[${index}][auto_include]`,
          item?.auto_include
        );
        formData.append(
          `packageAddons[${index}][price]`,
          convertDollarToCents(item?.price)
        );
        formData.append(`packageAddons[${index}][type]`, item?.type);
        formData.append(
          `packageAddons[${index}][description]`,
          item?.description
        );
        item?.addonImage?.file
          ? formData.append(
              `packageAddons[${index}][addonImage]`,
              item?.addonImage.file
            )
          : item.addonImage?.img
          ? formData.append(
              `packageAddons[${index}][addonImage]`,
              item.addonImage?.img
            )
          : item?.img !== undefined &&
            item.img !== "" &&
            formData.append(`packageAddons[${index}][addonImage]`, item?.img);
      });
      // for selected supplies in pkg
      selectedSupplies.map((item: string) => {
        formData.append("supply", item.toLowerCase());
      });
      setPayloadState(formData);
      setModal(true);
      // next && next();
    } else if (selectedType.length === 0) {
      setCustomError("type", "Atleast one type is required");
    }
  };

  const bartenderCosts = useWatch({ control: control, name: "bartenderCosts" });
  const bartenderProfit = useWatch({
    control: control,
    name: "bartenderProfit",
  });
  const suppliesCosts = useWatch({ control: control, name: "suppliesCosts" });
  const suppliesPrice = useWatch({ control: control, name: "suppliesPrice" });

  const addPackage = async () => {
    // create a new package
    try {
      startLoading();

      setModal(false);
      const res = await POST_MULTIPART(
        addPackageApi,
        payloadState,
        refreshToken
      )
      stopLoading();
      if (res.data.success) {
        Alert({ type: "success", message: res?.data?.message });
      } else {
        Alert({ type: "error", message: res?.data?.message });
      }
    } catch (error) {
      console.log("error", error);
      stopLoading();
    }
  };

  const uploadAddOnImg = (file: any) => {
    dispatch(formStateChange(true));

    try {
      const f = ImageUploadFunDropZone(file);
      if (f) {
        setAddOnImage({ img: URL.createObjectURL(f), file: f });
        // setCustomError("dp", "");
      }
    } catch (error: any) {
      console.log("error", error.message);
      setCustomError("dp", error.message);
    }
  };
  const removeAddOnImage = () => {
    setAddOnImage({ img: "" });
  };
  const goBack = () => {
    navigate(-1);
  };

  // clear allOn form
  const resetAddOnForm = () => {
    setAddOnName("");
    setAddOnDesc("");
    setAddOnPrice("");
    setAddOnType("bartender");
    setIncludeInPackage(false);
    setAddOnImage({ img: "" });
  };

  // Edit the addon from the table
  const editAddonForm = (item: addOnInterFace) => {
    dispatch(formStateChange(true));

    const { name, img, price, type, id, description, auto_include } = item;

    // if form is open edit mode
    if (!addAddOnForm) {
      setAddOnId(id);
      setAddOnImage({ img: img });
      setAddOnName(name);
      setAddOnPrice(price);
      setAddOnType(type);
      setIncludeInPackage(auto_include);
      setAddOnDesc(description);
      setAddOnIsEdit(true);
    } else {
      resetAddOnForm();
      setAddOnIsEdit(false);
    }
    setAddOnForm(!addAddOnForm);
  };
  const updateAddOn = () => {
    dispatch(formStateChange(true));

    const filteredAddOn = addOns.filter((item: any) => item.id !== addOnId);
    // In case user update the image of add on
    if (addOnImage) {
      setAddOns([
        ...filteredAddOn,
        {
          name: addOnName,
          price: addOnPrice,
          addonImage: addOnImage,
          description: addOnDesc,
          auto_include: includeInPackage,
          type: addOnType,
        },
      ]);
    } else {
      setAddOns([
        ...filteredAddOn,
        {
          name: addOnName,
          price: addOnPrice,
          img: addOnImage,
          description: addOnDesc,
          auto_include: includeInPackage,
          type: addOnType,
        },
      ]);
    }
    setAddOnForm(false);
    setAddOnIsEdit(false);
    resetAddOnForm();
  };
  console.log("addOnIsEdit", addOnIsEdit);
  return (
    <div >
      <DashboardHeader title="New Package"/>
      {/* <DashboardHeader title="Edit Package"></DashboardHeader> */}
      <form onSubmit={handleSubmit(onSubmit)} className="mx-auto">
        <div className="flex flex-col lg:flex-row gap-5">
          {/* left sec */}
          <div className="w-full flex flex-col gap-5 bg-white rounded-2xl  p-6 text-sm">
            <div className="flex gap-4 sm:flex-row flex-col">
              <div className="w-full ">
                <div className=" font-semibold my-2">Package Name *</div>
                <FormHookInput
                  updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  type="text"
                  maxLength={100}
                  placeholder="Package Name"
                  register={register("packageName", {
                    maxLength: {
                      value: 100,
                      message:
                        "Package Name can't be more than 100 characters.",
                    },
                    pattern: avoidEmptyStringValidator,
                    required: "Package Name is required",
                  })}
                  error={errors.packageName}
                />
              </div>
              <div className="w-full">
                <div className="font-semibold my-2">Type </div>
                <SelectSearchInput
                  disabled={false}
                  options={PACKAGES_TYPES}
                  value={selectedType}
                  onChange={(selectedValue: string) => {
                    setSelectedType(selectedValue);
                  }}
                />

                {error?.name === "type" && (
                  <p className="text-primary-red text-xs ">{error.message}</p>
                )}
              </div>
            
            </div>
            <div className="flex flex-col sm:flex-row gap-4 items-end">
            <div className="w-full">
                <div className=" font-semibold my-2">
                  How many guests per bartender *
                </div>

                <SelectSearchInput
                  options={guestsPerBartender}
                  value={selectedGuests}
                  onChange={(selectedValue: string) => {
                    setSelectedGuests(selectedValue);
                  }}
                />
              </div>
              <div className="w-full">
                <div className=" font-semibold my-2">
                  Your bartender hourly rate? ($) *
                </div>
                <FormHookInput
                  type="text"
                  updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  placeholder="Bartender Pay"
                  register={register("bartenderCosts", {
                    pattern: only2DecimalNumber,
                    required: "Bartender costs is required",
                    max: {
                      value: 999,
                      message:
                        "Bartender cost must not exceed the allowable limit",
                    },
                    min: {
                      value: 0.01,
                      message: "Bartender costs need to be greater than 0$",
                    },
                    onBlur: () => trigger("bartenderCosts"),
                  })}
                  error={errors.bartenderCosts}
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 item-end">
            <div className="w-full">
                <div className="flex items-center justify-between font-semibold my-2">
                  <div>Profit on bartender ($)</div>
                  <div className="text-xs font-semibold text-right">
                    Bartender Price:{" "} $
                    {formatNumber(
                      Number(bartenderCosts ? bartenderCosts : 0) +
                        Number(bartenderProfit ? bartenderProfit : 0)
                    )}{" "}
                  </div>
                </div>
                <FormHookInput
                  type="text"
                  updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  placeholder="Profit Margin"
                  register={register("bartenderProfit", {
                    pattern: only2DecimalNumber,
                    max: {
                      value: 999,
                      message:
                        "Profit on bartender must not exceed the allowable limit",
                    },
                    min: {
                      value: 0.0,
                      message: "Profit on bartender need to be greater than 0$",
                    },
                    onBlur: () => trigger("bartenderProfit"),
                  })}
                  error={errors.bartenderProfit}
                />
              </div>
              <div className="w-full">
                <div className=" font-semibold my-2">
                  Bartender prep time prior to event (minutes) *
                </div>
                <FormHookInput
                  updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  type="text"
                  placeholder="Prep Time"
                  register={register("prepTime", {
                    required: "Prep Time is required",
                    pattern: {
                      value: generateOnlyNumberRegex(),
                      message: "Only numbers are allowed",
                    },
                    max: {
                      value: 120,
                      message: "Prep Time can't be more than 120 minutes.",
                    },
                    min: {
                      value: 0,
                      message: "Prep Time can't be less than 0 minutes.",
                    },
                    onBlur: () => trigger("prepTime"),
                  })}
                  error={errors.prepTime}
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 items-end ">
              
            <div className="w-full">
                <div className=" font-semibold my-2">Delivery Fee ($) *</div>
                <FormHookInput
                  updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  type="text"
                  placeholder="Delivery Fee"
                  register={register("deliveryFee", {
                    pattern: only2DecimalNumber,
                    required: "Delivery fee is required",
                    max: {
                      value: 999,
                      message:
                        "Delivery fee must not exceed the allowable limit",
                    },
                    min: {
                      value: 0.01,
                      message: "Delivery fee need to be greater than 0$",
                    },
                    onBlur: () => trigger("deliveryFee"),
                  })}
                  error={errors.deliveryFee}
                />
              </div>
              <div className="w-full ">
                <div className=" font-semibold my-2">
                  Minimum hours to register
                </div>
                <SelectSearchInput
                  options={hoursToRegister}
                  value={hrToRegister}
                  onChange={(selectedValue: string) => {
                    setHrToRegister(selectedValue);
                  }}
                />
              </div>
            
            </div>
            <div className="flex  gap-4 items-end sm:flex-row flex-col">
            <div className="w-full ">
                <div className=" font-semibold my-2"> Minimum Price</div>
                <FormHookInput
                  type="text"
                  updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  placeholder=" Minimum Price"
                  register={register("minPrice", {
                    pattern: only2DecimalNumber,
                    // required: "Minimum Price",
                    max: {
                      value: 9999,
                      message: "Price must not exceed the allowable limit",
                    },
                    min: {
                      value: 0,
                      message: "Delivery fee need to be greater than 0$",
                    },
                    onBlur: () => trigger("minPrice"),
                  })}
                  error={errors.deliveryFee}
                />
              </div>
              <div className="w-full">
                <div className=" font-semibold my-2">
                  Want to make the tip-jar mendatory?
                </div>
                <SelectSearchInput
                  disabled={false}
                  options={TIPS_OPTIONS}
                  value={tipSelect}
                  onChange={(selectedValue: string) => {
                    setTipSelect(selectedValue);
                  }}
                />
              </div>
            </div>
            <div className="flex  gap-4 items-end sm:flex-row flex-col">
              <div className="w-full md:w-3/6">
                <div className=" font-semibold my-2">
                  Tip Fee Per Guest ($) *
                </div>
                {tipSelect == "true" ? (
                  <FormHookInput
                    updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                    type="number"
                    disabled={true}
                    placeholder="0.00"
                    error={errors.tipFee}
                  />
                ) : (
                  <FormHookInput
                    type="text"
                    placeholder="0.00"
                    updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                    register={register("tipFee", {
                      required: "Tips fee is required",
                      pattern: only2DecimalNumber,
                      min: {
                        value: 0.01,
                        message: "Tips need to be greater than 0$",
                      },
                      max: {
                        value: 999,
                        message: "Tips must not exceed the allowable limit",
                      },
                      //   required: "Tip prep Time is required",
                      onBlur: () => trigger("tipFee"),
                    })}
                    error={errors.tipFee}
                  />
                )}
              </div>
             
            </div>
            <div className="flex gap-4 items-end sm:flex-row flex-col">
            
            </div>
           
            <div className="w-full ">
              <div className=" font-semibold my-2">Package Description</div>
              <FormHookTextArea
                rows={12}
                updatedStyle="w-full px-4 py-3 bg-p-gray rounded-xl    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                type="text"
                placeholder="Package Description"
                register={register("description", {
                  pattern: avoidEmptyStringValidator,
                })}
                error={errors.description}
              />
            </div>
          </div>
          {/* right */}
          <div className="w-full md:w-7/12">
            <div className="w-full flex-1 flex flex-col  gap-5 bg-white rounded-2xl  p-6  ">
              <div>
                <div className=" font-semibold my-2 flex justify-between items-center">
                  <p>{"What's included in your package?"}</p>
                  <FaCirclePlus
                    className="cursor-pointer text-gray-400 text-xl"
                    onClick={openModal}
                  />
                </div>
                <div className="flex w-fit flex-wrap gap-3 pr-2 mt-4 overflow-y-auto max-h-52">
                  {suppliesList.map((item, index) => {
                    return (
                      <div key={index}>
                        <button
                          type="button"
                          onClick={() =>
                            selectSupply(selectedSupplies.includes(item), item)
                          }
                          className={` ${
                            selectedSupplies.includes(item)
                              ? "bg-primary-red text-white"
                              : "bg-gray-200 text-black"
                          }  rounded-full px-3 py-1 cursor-pointer`}
                        >
                          {item}
                        </button>
                      </div>
                    );
                  })}
                </div>
                <div className="flex items-center text-blackgap-3 mt-4"></div>

                {suppliesError && (
                  <p className="text-primary-red text-xs ">{suppliesError}</p>
                )}
                {/* new supply form */}
                {addSupplyForm && (
                  <FormModal
                    overflow="overflow-hidden "
                    modalTitle="Add Supply"
                    isOpen={addSupplyForm}
                    width="lg:w-3/6 md:w-5/6 w-full"
                    height="overflow-y-auto"
                    onClose={closeModal}
                  >
                    <div className="w-full ">
                      <div className="font-semibold my-2">Supply Name</div>
                      <input
                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"

                        maxLength={50}
                        value={supplyInput}
                        onChange={(e) => setSupplyInput(e.target.value)}
                        type="text"
                        placeholder="Supply Name"
                      />
                      {addError && (
                        <p className="text-primary-red text-xs ">{addError}</p>
                      )}
                      <div className="flex justify-end mt-2 ">
                        {/* <Button type="button" onClick={addNewSupply}>
                        Add
                      </Button> */}
                        <p
                          className="text-sm text-white rounded-full px-5 py-2 bg-primary-red cursor-pointer"
                          onClick={addNewSupply}
                        >
                          Add
                        </p>
                      </div>
                    </div>
                  </FormModal>
                )}
              </div>
            </div>
           
            <div className="w-full flex-1 flex flex-col gap-5 bg-white rounded-2xl  p-6 mt-8 ">
              <div className="flex">
                <div className="w-full">
                  <div className=" font-semibold my-2">
                    How much does the above supplies cost per cocktail? ($)*
                  </div>
                  <div className="text-end text-xs font-semibold mb-1">
                    Per Cocktail:{" "} $
                    {(
                      Number(suppliesCosts ? suppliesCosts : 0) +
                      Number(
                        suppliesPrice
                          ? (suppliesPrice / 100) * suppliesCosts
                          : 0
                      )
                    ).toFixed(2)}{" "}
                  </div>
                  <FormHookInput
                    type="text"
                    updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                    placeholder="Supply Costs"
                    register={register("suppliesCosts", {
                      required: "Supply cost is required",
                      pattern: only2DecimalNumber,
                      max: {
                        value: 999,
                        message:
                          "Supply cost must not exceed the allowable limit",
                      },
                      min: {
                        value: 0.01,
                        message: "Supply cost need to be greater than 0$",
                      },
                      onBlur: () => trigger("suppliesCosts"),
                    })}
                    error={errors.suppliesCosts}
                  />
                </div>
              </div>
              <div className="flex">
                <div className="w-full">
                  <div className=" font-semibold my-2">
                    Percentage of profit would you like to keep on the supplies?
                    *
                  </div>
                  <FormHookInput
                    updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                    type="text"
                    placeholder="Suplies Percentage (%)"
                    register={register("suppliesPrice", {
                      required: "Supplies Percentage is required",
                      pattern: onlyPercentageValidation,
                      onBlur: () => trigger("suppliesPrice"),
                    })}
                    error={errors.suppliesPrice}
                  />
                </div>
              </div>
            </div>
             {/* Add Ons Card */}
             <div className="w-full flex-1 flex flex-col gap-5  bg-white rounded-2xl  p-6  mt-8 ">
              <div className=" ">
                <div className="flex  justify-between">
                  <div className=" font-semibold  py-2 ">{"Add-ons"}</div>
                  <div className="flex items-center text-black ">
                    {/* <p
                      className="text-3xl flex items-center justify-center cursor-pointer pb-2 bg-primary-red text-white rounded-full w-6 h-6 mr-3"
                      onClick={() => setAddOnForm(!addAddOnForm)}
                    >
                      +
                    </p> */}
                    <FaCirclePlus
                      className="cursor-pointer text-gray-400 text-xl"
                      onClick={() => {
                        setAddOnIsEdit(false);
                        setAddOnName("");
                        setAddOnImage({ img: "" });
                        setAddOnPrice("");
                        setAddOnType("bartender");
                        setAddOnDesc("");
                        setAddOnForm(true);
                        setIncludeInPackage(false);
                      }}
                    />
                  </div>
                </div>
                <div className="overflow-y-auto max-h-72">
                  {addOns?.length > 0 &&
                    addOns.map((item: any, index: number) => {
                      return (
                        <div
                          className="flex justify-between items-center bg-gray-100  rounded-xl p-3 mb-2"
                          key={index}
                        >
                          <div className="flex items-center gap-2">
                            <Input
                              className="cursor-pointer w-6  accent-primary-red"
                              style={{ zoom: 1.2 }}
                              type="checkbox"
                              checked={item.auto_include}
                              onChange={(e) =>
                                updateAddon(item.name, !item.auto_include)
                              }
                            />
                            <div className="flex gap-2">
                              {item?.addonImage &&
                              item?.addonImage !== undefined &&
                              item.addonImage?.img !== "undefined" &&
                              item.addonImage?.img !== "" ? (
                                <img
                                  src={item?.addonImage?.img}
                                  width={60}
                                  height={60}
                                  alt="alt"
                                  className="w-14 h-14 rounded-xl"
                                />
                              ) : item?.img !== "undefined" &&
                                item.img &&
                                item.addonImage?.img !== "undefined" &&
                                item.addonImage?.img !== "" ? (
                                <img
                                  src={item?.img}
                                  className="w-14 h-14 rounded-xl"
                                  alt="alt2"
                                />
                              ) : (
                                ""
                              )}
                              <div>
                                <p className="tracking-wide">{item.name}</p>
                                <p className="text-sm">
                                  Price:{" "}
                                  <span className="text-gray-500">
                                    ${item.price}
                                  </span>
                                </p>
                                <p className="text-xs">
                                  {item.auto_include
                                    ? "Included in package"
                                    : "Excluded from package "}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="px-6 py-2 flex justify-center items-center gap-2 ">
                            <div
                                data-testid="delete-icon "
                                className="p-2 bg-p-gray rounded-full font-bold cursor-pointer"
                                onClick={() => {
                                  deleteAddOn(index);
                                }}
                              >
                                <img src={deleteIcon} />
                              </div>

                              {item.id && (
                                <div
                                  className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                                  onClick={() => editAddonForm(item)}
                                >
                                  <FiEdit2 size={14} />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>

                {/* new supply form */}

                <FormModal
                  overflow="overflow-hidden "
                  modalTitle={addOnIsEdit ? "Update Add-on" : "Create Add-on"}
                  isOpen={addAddOnForm}
                  width="lg:w-3/6 md:w-5/6 w-full"
                  height="overflow-y-auto"
                  onClose={closeAddOnModal}
                >
                  <div className="mt-2 px-3">
                    <div className="flex gap-4 justify-between sm:items-start flex-col sm:flex-row items-center">
                      <div className="flex-2 "> 
                      <Dropzone

                        image={
                          addOnImage?.img !== "undefined" && addOnImage?.img
                        }
                        imgStyle={'w-24 h-24 rounded-xl'}
                        removeImage={() => removeAddOnImage()}
                        onDrop={uploadAddOnImg}
                        // classname="w-20 h-20 py-2 mr-2 rounded-xl object-cover"
                      ></Dropzone>
                      </div>

                      <div className="flex flex-col gap-1 w-full flex-1 ">
                        <div className="flex gap-2 flex-col sm:flex-row">
                          <input
                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"

                            maxLength={50}
                            value={addOnName}
                            onChange={(e) => setAddOnName(e.target.value)}
                            type="text"
                            placeholder="Name"
                          />
                          <input
                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"

                            value={addOnPrice}
                            onChange={(e) => setAddOnPrice(e.target.value)}
                            type="number"
                            placeholder="Price"
                            step={0.01}
                            max={999}
                          />
                        </div>
                        <div className="flex gap-2  flex-col sm:flex-row">
                        <SelectInput
                          border="none"
                          classes="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                          rounded="rounded-full" 
                          disabled={false}
                            options={addOnsTypes}
                            value={addOnType}
                            onChange={(selectedValue: string) => {
                              setAddOnType(selectedValue);
                            }}
                          />
                          <input
                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"

                            maxLength={200}
                            value={addOnDesc}
                            onChange={(e) => setAddOnDesc(e.target.value)}
                            type="text"
                            placeholder="Description"
                          />
                        </div>
                        <div className="mt-3 flex flex-row gap-2">
                          <label htmlFor="">Include in Package</label>
                          <Input
                            className="cursor-pointer w-4 accent-primary-red"
                            type="checkbox"
                            checked={includeInPackage}
                            onChange={(e) =>
                              setIncludeInPackage(!includeInPackage)
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {addOnError && (
                      <p className="text-primary-red text-xs ">{addOnError}</p>
                    )}
                    <div className="flex justify-end mt-2">
                      <Button
                        type="button"
                        classes="text-sm text-white rounded px-3 py-2 bg-primary-red cursor-pointer"
                        onClick={addOnIsEdit ? updateAddOn : addAddOn}
                      >
                        {addOnIsEdit ? "Update" : "Add"}
                      </Button>
                    </div>
                  </div>
                </FormModal>
              </div>
            </div>
            <div className="flex justify-end gap-4 mt-4">
              <Button
                classes={
                  "bg-primary-red text-white hover:bg-primary-red-button-hover "
                }
                type="submit"
                disabled={isLoading}
              >
                {" "}
                {isLoading ?  <Loader  color="bg-gray-50" /> : "Save"}
              </Button>
            </div>
          </div>
        </div>
      </form>

      <ChangesAlert
        title={"Save Changes"}
        desc={`Are you sure you want to save this changes?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setModal(false);
        }}
        handleSaveChanges={addPackage}
        isOpen={modal}
      />
    </div>
  );
};

export default NewPackageBTC;
